import {
  GET_NOTIFICATION_START,
  GET_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_FAIL,
  SEND_NOTIFICATION_START,
  SEND_NOTIFICATION_SUCCESS,
  SEND_NOTIFICATION_FAILS,
  RESET_NOTIFICATION_ALERT,
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_FAILED,
  SEND_EMP_MAIL,
  SEND_EMP_MAIL_SUCCESS,
  SEND_EMP_MAIL_FAILED,
} from "./constant"

export const getNotificationStart = () => {
  console.log("are you running")
  return {
    type: GET_NOTIFICATION_START,
  }
}

export const getNotificationSuccess = payload => {
  return {
    type: GET_NOTIFICATION_SUCCESS,
    payload: payload,
  }
}

export const getNotificationFailure = error => {
  return {
    type: GET_NOTIFICATION_FAIL,
    payload: error,
  }
}

export const sendNotificationStart = payload => {
  return {
    type: SEND_NOTIFICATION_START,
    payload
  }
}

export const sendNotificationSuccess = payload => {
  return {
    type: SEND_NOTIFICATION_SUCCESS,
    payload
  }
}

export const sendNotificationFail = payload => {
  return {
    type: SEND_NOTIFICATION_FAILS,
    payload
  }
}

export const resetNotificationAlert = () => {
  return {
    type: RESET_NOTIFICATION_ALERT
  }
}


export const deleteNotification = (payload) => {
  return {
    type: DELETE_NOTIFICATION,
    payload
  }
}

export const deleteNotificationSuccess = (payload) => {
  return {
    type: DELETE_NOTIFICATION_SUCCESS,
    payload
  }
}

export const deleteNotificationFailed = (payload) => {
  return {
    type: DELETE_NOTIFICATION_FAILED,
    payload
  }
}

export const sendEmpMail = (payload) =>{
  return{
    type: SEND_EMP_MAIL,
    payload
  }
}

export const sendEmpMailSuccess = (payload) =>{
  return{
    type: SEND_EMP_MAIL_SUCCESS,
    payload
  }
}

export const sendEmpMailFailed = (payload) =>{
  return{
    type: SEND_EMP_MAIL_FAILED,
    payload
  }
}